import {Component, OnInit, Input} from '@angular/core';
import {TipoModalCarregando} from '../../enum/tipo-modal-carregando.enum';
import {EventEmitterService} from '../../../../../services/event-emitter.service';

@Component({
    selector: 'modal-carregando',
    templateUrl: './modal-carregando.component.html',
    styleUrls: ['./modal-carregando.component.scss'],
})
export class ModalCarregandoComponent implements OnInit {

    carregando = true;

    lottieConfig = {
        path: 'assets/lottie/programando.json',
        renderer: 'canvas',
        autoplay: true,
        loop: true
    };

    private subscribeAtualizarMensagem: any;

    @Input() mensagem = 'Carregando Dados';
    @Input() tipo: TipoModalCarregando;

    constructor() {
        this.subscribeAtualizarMensagem = EventEmitterService.get('atualizar-dados-exportacao').subscribe((data) => {
            this.mensagem = data || 'Carregando Dados';
        });
    }

    ngOnInit() {
        this.configurarModalCarregamento();
        this.carregando = true;
        setTimeout(() => {
            this.carregando = false;
        }, 100);
    }

    async configurarModalCarregamento() {
        switch (this.tipo) {
            case TipoModalCarregando.CarregandoLista:
                await this.modalCarregandoLista();
                break;
            case TipoModalCarregando.Exportando:
                await this.modalExportacao();
                break;
            default:
                await this.modalCarregando();
                break;
        }

    }

    async modalCarregando() {
        this.lottieConfig.path = 'assets/lottie/carregando-lista.json';
    }

    async modalExportacao() {
        this.lottieConfig.path = 'assets/lottie/exportacao.json';
    }

    async modalCarregandoLista() {
        this.lottieConfig.path = 'assets/lottie/carregando-lista.json';
    }

    private pegarNumeroAleatorio(min, max) {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min)) + min;
    }

}
